import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import * as Yup from 'yup';
import { Formik, Field, Form } from 'formik';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { validationMessages } from '../../../i18n/common';
import { LegacyInputTextComponent } from '../../../components/prime-formik';
import useSubscriptionExpiredRestrictions from '../../../hooks/useSubscriptionExpiredRestrictions';

const EditTeamReportContainer = ({ onUpdate, onCancel, teamReport }) => {
  const { formatMessage } = useIntl();

  const initialValues = { teamName: teamReport.teamName };
  const validationSchema = Yup.object().shape({
    teamName: Yup.string().required(formatMessage(validationMessages.required)),
  });

  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  return (
    <Formik onSubmit={onUpdate} initialValues={initialValues} validationSchema={validationSchema}>
      {({ isSubmitting }) => (
        <Form>
          <Panel header={`${teamReport.teamName}`}>
            <div className="p-grid">
              <div className="p-col-12">
                <div className="{{if errors.name 'has-error'}}">
                  <label className="field-label" htmlFor="teamName">
                    <FormattedMessage id="team_report.team_name" defaultMessage="Team Name" />
                  </label>
                  <Field id="teamName" type="text" name="teamName" component={LegacyInputTextComponent} />
                </div>
              </div>
              <div className="p-col-12">
                <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
                  {text => <Button type="button" label={text} className="p-button-secondary" onClick={onCancel} />}
                </FormattedMessage>
                <FormattedMessage id="actions.save" defaultMessage="Save">
                  {text => <Button type="submit" label={text} disabled={isSubmitting || subscriptionIsExpired} />}
                </FormattedMessage>
              </div>
            </div>
          </Panel>
        </Form>
      )}
    </Formik>
  );
};

EditTeamReportContainer.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  teamReport: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default EditTeamReportContainer;
